import { render, staticRenderFns } from "./value_streams_dashboard_link.vue?vue&type=template&id=19b2ac6a"
import script from "./value_streams_dashboard_link.vue?vue&type=script&lang=js"
export * from "./value_streams_dashboard_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports